import { sizeType } from './interface';

export function getWidth(size?: sizeType) {
  if (size === undefined) return 720;
  if (typeof size === 'number') return size;
  if (size === 'small') return '45%';
  if (size === 'middle') return '60%';
  if (size === 'large') return '80%';
}
